import {
    AfterContentInit,
    ChangeDetectionStrategy,
    Component,
    Type,
    ViewChild,
    ViewContainerRef,
    inject
} from "@angular/core";
import { NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Observable, Subject } from "rxjs";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { HeaderComponent } from "../header/header.component";
import { ModalComponentMediator } from "./modal-component-mediator";

@Component({
    selector: "rask-modal",
    styleUrls: ["./modal.component.scss"],
    templateUrl: "./modal.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent]
})
export class ModalComponent implements AfterContentInit {
    @ViewChild("container", {
        read: ViewContainerRef,
        static: true
    }) container: ViewContainerRef;
    data: any;
    dialogRef: NgbModalRef;
    header = "Header";
    inner: Type<any>;
    showClose = true;

    cancel = ConfirmDialogResponse.cancel;
    innerComponent: any;
    private readonly componentObserver = new Subject();
    private readonly modalComponentMediator = inject(ModalComponentMediator);

    constructor() {
        const modalComponentMediator = this.modalComponentMediator;

        this.inner = modalComponentMediator.getType();
    }

    close(result: any) {
        if (!this.dialogRef) {
            this.dialogRef = this.modalComponentMediator.getRef();
        }
        this.dialogRef.close(result);
    }

    getInnerComponent<T>(): Observable<T> {
        return this.componentObserver.asObservable() as Observable<T>;
    }

    ngAfterContentInit() {
        this.innerComponent = this.container.createComponent(this.inner);
        this.innerComponent.instance.data = this.data;
        this.componentObserver.next(this.innerComponent.instance);
    }
}
